import React from 'react'
import './index.scss'
import { useFormContext } from 'react-hook-form'
import clsx from 'clsx'
import FormFieldProps from '@App/forms/v2/common/form-field'
import FieldErrorSectionForm from '@App/kit/fields/v2/FieldErrorSectionForm'
import getInputName from '@App/forms/v2/helpers/get-input-name'
import getFormError from '@App/forms/v2/helpers/get-form-error'

const LineNumber = (props: FormFieldProps) => {
    const { register, formState } = useFormContext()

    const name = getInputName(props)
    const fieldError = getFormError(props, formState.errors)
    const innerClassNames = clsx('input-text-form-component', 'main-color-set', !!fieldError && 'error')
    return (
        <div className="input-line-number" data-testid={name}>
            <div className={innerClassNames}>
                <label htmlFor={name} />
                <input {...register(name)} />
                <FieldErrorSectionForm {...props} fieldError={fieldError} />
            </div>
        </div>
    )
}

export default LineNumber
